module.exports = __webpack_public_path__ + "img/title1.b11079c.webp";